import { render, staticRenderFns } from "./message-list.vue?vue&type=template&id=da74aff2&scoped=true"
import script from "./message-list.vue?vue&type=script&lang=ts"
export * from "./message-list.vue?vue&type=script&lang=ts"
import style0 from "./message-list.vue?vue&type=style&index=0&id=da74aff2&prod&lang=scss&scoped=true"
import style1 from "./message-list.vue?vue&type=style&index=1&id=da74aff2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da74aff2",
  null
  
)

export default component.exports